define('entities/mbamodels',[
  'app',
  'backbone',
  'settings',
  'jquery',
  'underscore'
], function(
  App,
  Backbone,
  Settings,
  $,
  _
) {
  'use strict';

  var MbAModel = Backbone.Model.extend({
    fetch: function() {
      this.url = Settings.url('compuzz', 'v2/mbamodels/' + this.get('secId'));

      return Backbone.Model.prototype.fetch.call(this);
    },
    defaults: {
      code: '',
      name: '',
      description: ''
    },
    idAttribute: 'secId',
    getImageUid:function() {},

    postUrl: function () {
      return Settings.url('compuzz', 'v2/mbamodels');
    },

    save: function() {
      this.url = this.postUrl();
      return Backbone.Model.prototype.save.call(this);
    }
  });

  var MbAModelCollection = Backbone.Collection.extend({
    url: function() {
      return Settings.url('compuzz', 'v2/mbamodels');
    },
    model: MbAModel
  });

  var API = {

    getMbAModelCollectionUrl: function() {
      new MbAModelCollection();
      var params = {};
      return Settings.url('compuzz', 'v2/mbamodels', params);
    },

    getAllMbAModels: function(params) {
      var url = Settings.url('compuzz', 'v2/mbamodels', params),
          defer = $.Deferred();

      $.ajax({
        method: 'get',
        url: url,
        success: function(items) {
          var list = [];
          _.each(items, function(item){
            list.push(item.secId);
          });
          defer.resolve(list);
        }
      });

      return defer.promise();
    },

    getMbAModelCountUrl: function() {
      var params = '';
      return 'v2/mbamodels/rowCount' + params;
    },

    deleteMbAModel: function(secId){
      var url = Settings.url('compuzz', 'v2/mbamodels/'+secId),
          defer = $.Deferred();

      $.ajax({
        type: 'DELETE',
        url: url,
        success: function (data) {
          defer.resolve(data);
        }
      });

      return defer.promise();
    }
  };

  App.reqres.setHandler('mbamodel:get-collection-url', function() {
      return API.getMbAModelCollectionUrl();
  });

  App.reqres.setHandler('mbamodel:get-collection-to-page', function(params) {
      return API.getAllMbAModels(params);
  });

  App.reqres.setHandler('mbamodel:get-count-url', function() {
    return API.getMbAModelCountUrl();
  });

  App.reqres.setHandler('mbamodel:model', function(itemJSON) {
    return new MbAModel(itemJSON);
  });

  App.reqres.setHandler('mbamodel:delete', function(secId) {
    return API.deleteMbAModel(secId);
  });
});
